import Result, { EmptyResult } from "../Result";
import { Record, Storage } from "./types";

export class SessionStorage implements Storage {
  public getName(): string {
    return 'SessionStorage';
  }

  public async get(key: string): Promise<Result<string | null>> {
    const value = sessionStorage.getItem(key);

    return new Result(value);
  }

  public async put({ key, value, permanent }: Record): Promise<Result> {
    if (!permanent) {
      console.debug(`Saving item {${key}} to a session storage`);
      sessionStorage.setItem(key, value);
    }

    return new EmptyResult();
  }

  public async remove({ key }: { key: string; }): Promise<EmptyResult> {
    console.debug(`Remove item {${key}} form session storage`);
    sessionStorage.removeItem(key);

    return new EmptyResult();
  }
}
